import { sendSuccessNotice, sendErrorNotice } from '@/commons/utils';
import { request_list, update_detail, request_header } from '@/commons/hpod';
import configs from '@/configs';
import Vue from 'vue';
const endpoint = 'deliverable'
// initial state
const state = {
    loading: false,
    all: {}
};

// getters
const getters = {};

// actions
const actions = {
    getList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint, data => {
            commit('setList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    setDetail({ commit, dispatch }, {param, data, notifySuccess = true} ) {
        commit("setLoading", { loading: true });
        return new Promise((resolve, reject) => {
            update_detail(endpoint, res => {
                if (res.data.status === 'fail') {
                    sendErrorNotice('Không thể cập nhật mã vận đơn.');
                    reject(res.data);
                }
                else {
                    if (notifySuccess) {
                        sendSuccessNotice('Cập nhật mã vận đơn thành công.');
                    }
                    if (param) {
                        dispatch("getList", param);
                    }
                    resolve(res.data);
                }
                commit("setLoading", { loading: false });
            }, Vue.http, data, data.ID, this.state.authentication.token);
        });
    },
    createReceipt({ commit, dispatch }, { uid, packageIds, customerInfo, tableConfig, refreshList = true, notifySuccess = true }) {
        commit("setLoading", { loading: true });
        const payload = {
            UID: uid,
            Username: customerInfo.Username,
            Receiver: customerInfo.Receiver || customerInfo.Username,
            Phone: customerInfo.Phone || '',
            Address: customerInfo.Address || '',
            Status: 'chuan_bi',
            package_ids: packageIds
        };
        const headers = {
            headers: request_header(this.state.authentication.token)
        };

        return Vue.http.put(`${configs.API}/admin/api/export-receipt/`, payload, headers)
            .then(res => {
                const data = res.data || {};
                if (data.status === 'fail') {
                    sendErrorNotice(data.reason || 'Không thể tạo phiếu xuất kho.');
                    throw data;
                }
                if (notifySuccess) {
                    sendSuccessNotice('Tạo phiếu xuất kho thành công.');
                }
                if (refreshList && tableConfig) {
                    dispatch("getList", tableConfig);
                }
                return data;
            })
            .catch(err => {
                if (err && err.status === 401) {
                    window.getApp.$emit("APP_AUTH_FAILED");
                } else {
                    const reason = (err && err.data && err.data.reason) || err.reason || 'Không thể tạo phiếu xuất kho.';
                    sendErrorNotice(reason);
                }
                throw err;
            })
            .finally(() => {
                commit("setLoading", { loading: false });
            });
    }
};

// mutations
const mutations = {
    setList(state, data) {
        state.all = data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
